var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burger-menu"},[_c('div',{staticClass:"burger",class:{active:_vm.show},on:{"click":_vm.toggleClick}},[_c('div',{staticClass:"item"}),_c('div',{staticClass:"item"})])])}
var staticRenderFns = []

export { render, staticRenderFns }